export const pifChangableFieldsConfig = {
	currentWorkingStatus: false,
	graduationYear: false,
	currentRole: false,
	currentCompany: false,
	currentSalary: false,
	expectedJoining: false,
	expectedSalary: false,
	preferredJobLocations: false,
	lastRole: false,
	lastCompany: false,
	lastDrawnSalary: false,
	pifMeta: {
		gender: true,
		internshipExperience: false,
		totalExperience: false,
		relevantTechExperience: false,
		dateOfBirth: false,
		location: {
			state: true,
			city: true,
			pincode: true,
		},
		highestQualifications: true,
		tenth: {
			percentage: false,
			board: false,
		},
		twelfth: {
			percentage: false,
			board: false,
		},
		diplomaAfterTenth: {
			percentage: false,
			board: false,
			collegeUniversityName: false,
		},
		diplomaAfterTwelfth: {
			percentage: false,
			board: false,
			collegeUniversityName: false,
		},
		underGraduate: {
			percentage: false,
			collegeUniversityName: false,
			isBacklog: false,
			degree: false,
			specialisation: false,
		},
		postGraduate: {
			percentage: false,
			collegeUniversityName: false,
			isBacklog: false,
			degree: false,
			specialisation: false,
		},
		tenthMarksheetDoc: false,
		twelfthMarksheetDoc: false,
		highestQualificationMarksheetDoc: false,
		panCardDoc: false,
		aadhaarCardDocFront: false,
		aadhaarCardDocBack: false,
		guardianMobileNumber: false,
		primaryCommunicationPhoneNumber: true,
		primaryCommunicationEmail: true,
		linkedinUrl: true,
		githubProfileLink: true,
		leetcodeProfileLink: true,
		hackerRankProfileLink: true,
		facebookProfileLink: true,
		instagramProfileLink: true,
		clubsInvolvedInCollege: true,
		hobbies: true,
		achievements: true,
	},
};
